import React from 'react';
import {view} from '@sail/ui';
import {COLORS} from 'src/v2/util/color';
import {BackButton} from 'src/v2/components/common/BackButton';

export const AnyCryptoWrapper = ({
  children,
  onBack,
}: {
  children: React.ReactNode;
  onBack?: () => void;
}) => {
  return (
    <view.div
      css={{
        stack: 'y',
        width: '388px',
        gapY: 'medium',
        boxShadow:
          '0px -4px 32px rgba(0, 0, 0, 0.04), 0px 12px 32px rgba(0, 0, 0, 0.04)',
        borderRadius: '20px',
        borderWidth: 'small',
        paddingX: 'large',
        paddingY: 'xlarge',
        backgroundColor: COLORS.defaultBackgroundColor,
        flex: 'none',
      }}
    >
      {onBack ? <BackButton onBack={onBack} /> : null}
      {children}
    </view.div>
  );
};
